document.addEventListener("DOMContentLoaded", function (event) {
    "use strict";

    $(".container-slider .mySwiper").each(function (i) {
        new Swiper($(this)[0], {
            navigation: {
                nextEl: $(".container-slider .swiper-button-next")[i],
                prevEl: $(".container-slider .swiper-button-prev")[i],
            },
            slidesPerView: 2,
            spaceBetween: 15,
            loop: false,
            autoplay: 8000,
            breakpoints: {
                768: {
                    slidesPerView: 3,
                    spaceBetween: 40,
                },
                1024: {
                    slidesPerView: 4,
                    spaceBetween: 50,
                },
            },
        });
    });


    $(".container-treeSlider .treeSlider").each(function (i) {
        new Swiper($(this)[0], {
            slidesPerView: 1,
            spaceBetween: 15,
            loop: true,
            autoplay: 8000,
            breakpoints: {
                768: {
                    slidesPerView: 2,
                },
                992: {
                    slidesPerView: 3,
                },
            },
            navigation: {
                nextEl: $(".container-treeSlider .swiper-button-next")[i],
                prevEl: $(".container-treeSlider .swiper-button-prev")[i],
            },
        });
    });




    new Swiper( '.js__sliderCategory', {
        slidesPerView: 'auto',
        spaceBetween: 15,
        navigation: {
            nextEl: '.sliderCategory .swiper-button-next',
            prevEl: '.sliderCategory .swiper-button-prev',
        },
    });

        new Swiper( '.treeSliderInsideBtn', {
            slidesPerView: 1,
            spaceBetween: 15,
            loop: true,
            autoplay: 8000,
            breakpoints: {
                768: {
                    slidesPerView: 2,
                    loop: true
                },
                992: {
                    slidesPerView: 3,
                    loop: false,
                    watchOverflow: true
                },
            },
            navigation: {
                nextEl: '.swiper-button-next',
                prevEl: '.swiper-button-prev',
            },
        });




    $('.slidern #slider').owlCarousel({
        autoplay: 8000,
        singleItem: true,
        margin: 20,
        navText: false,
        animateOut: 'fadeOut',
        responsive: {
            0: {
                items: 1,
                nav: false,
                dots: false
            },
            768: {
                items: 2,
                nav: true,
                dots: true
            }
        }
    })

});
